import { useQuery } from "@tanstack/react-query";
import { useLanguage } from "../i18n/LanguageContext";
import { getFreelancerProjects } from "../api/projects-api";
import { Project } from "../models/Project";
import { PaginatedResponse } from "../models/Pagination";

/**
 * Hook to get freelancer's associated projects - uses the same API as clients
 * @param page Page number (1-based)
 * @param pageSize Items per page
 * @param status Optional status filter
 * @param name Optional name filter
 * @param projectNumber Optional project number filter
 * @param sortField Optional sort field
 * @param sortDirection Optional sort direction ('asc' or 'desc')
 */
export const useFreelancerProfileProjects = (
  page = 1, 
  pageSize = 10, 
  status?: string,
  name?: string,
  projectNumber?: string,
  sortField?: string,
  sortDirection?: string
) => {
  const { currentLanguage } = useLanguage();

  return useQuery<PaginatedResponse<Project>, Error>({
    queryKey: ["freelancerProfileProjects", page, pageSize, status, name, projectNumber, sortField, sortDirection, currentLanguage],
    queryFn: () => getFreelancerProjects(page, pageSize, status, name, projectNumber, sortField, sortDirection),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};